<svelte:options customElement={{
  tag: 'content-spacer',
  shadow: 'none',
  props: {
    variant: { reflect: true, type: 'String' }
  }
}} />

<script>
  import { onMount } from 'svelte';
  /**
   * マージンルール・コンテンツ間余白設定
   * パーツライブラリ準拠の mod-spacer-* 構造
   * @prop {string} variant - スペーサー種別:
   *   'section' (mod-spacer-section 80px/40px) - コンテンツ間余白大
   *   'default' (mod-spacer 56px/32px) - サブコンテンツ上マージン
   *   'small' (mod-spacer-small 24px/16px) - テキスト段落上マージン
   *   '64' (mod-spacer_64 64px/36px)
   *   '32' (mod-spacer_32 32px/20px)
   *   '16' (mod-spacer_16 16px/8px)
   *   '10' (mod-spacer_10 10px/8px)
   */
  export let variant = 'default';

  const classMap = {
    section: 'mod-spacer-section',
    default: 'mod-spacer',
    small: 'mod-spacer-small',
    '64': 'mod-spacer_64',
    '32': 'mod-spacer_32',
    '16': 'mod-spacer_16',
    '10': 'mod-spacer_10'
  };

  $: className = classMap[variant] || 'mod-spacer';

  let wrapperEl;

  onMount(() => {
    const host = wrapperEl.parentElement;
    const nodesToMove = [];
    host.childNodes.forEach(node => {
      if (node !== wrapperEl) nodesToMove.push(node);
    });
    nodesToMove.forEach(node => wrapperEl.appendChild(node));
  });
</script>

<div class={className} bind:this={wrapperEl}></div>
